<template>
    <tr>
        <td>
            <div class="d-flex px-2 py-1">
                <div>
                    <img :src="`https://mc-heads.net/avatar/${this.user}`" class="avatar avatar-sm me-3" :alt="`Główka ${this.user}`" />
                </div>
                <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ this.user }}</h6>
                </div>
            </div>
        </td>
        <td>
            <p class="text-xs font-weight-bold mb-0">{{ this.administrator }}</p>
        </td>
        <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">{{ this.reason }}</span>
        </td>
        <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">{{ this.date }}</span>
        </td>
        <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">{{ this.expire }}</span>
        </td>
    </tr>
</template>
<script>
export default {
    name: "kara",
    props: {
        user: String,
        administrator: String,
        type: String,
        date: String,
        expire: String,
        reason: String,
    }
}
</script>